import React from "react";
import { EnglishCanvas } from "./EnglishCanvas";
import { HindiCanvas } from "./HindiCanvas";

const GenerateCanvas = ({ score, title }) => {
    let lang = "en";
    let user = "Guest";
    let karyt = {};
    let isScoreShow = true;
    try {
        lang = localStorage.getItem("lang");
        user = localStorage.getItem("userName");
        karyt = JSON.parse(localStorage.getItem("karyakartas"));
    } catch (e) { }
    
    if (score <= 5) {
        isScoreShow = false;
    }

    if (karyt && karyt.state && karyt.vsabha, karyt.boothno) {
        let boothDetails = {
            state:karyt.state,
            vsabha: karyt.vsabha,
            boothno: karyt.boothno,
        }
        return (
            <div className="generate_canvas" style={{ height: "1200px" }}>
                <div className="" style={{ margin: "0px" }}>
                    {lang === 'hi' ?
                        <HindiCanvas user={user} score={score} type="karyakarta" boothDetails={boothDetails} isScoreShow={isScoreShow} title={title} />
                        : <EnglishCanvas user={user} score={score} type="karyakarta" boothDetails={boothDetails} isScoreShow={isScoreShow} title={title} />}
                </div>
            </div>
        )
    } else {
        return (
            <div className="generate_canvas" style={{ height: "1200px" }}>
                <div className="" style={{ margin: "0px" }}>
                    {lang === 'hi' ?
                        <HindiCanvas user={user} score={score} type="nmuser" isScoreShow={isScoreShow} title={title} />
                        : <EnglishCanvas user={user} score={score} type="nmuser" isScoreShow={isScoreShow} title={title} />}
                </div>
            </div>
        )
    }

};
export default GenerateCanvas;